import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
import { UserDetailsService } from "../services/userDetailsService";

class Slide2_4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spokenTo: [],
      errors: {},
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "Slide2_4",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });

    // Use centralized service to fetch user details
    UserDetailsService.fetchAndUpdateState(
      this.props.values.requestId,
      this,
      'spokenTo',
      {
        componentName: "Slide2_4",
        medium: this.props.values.medium,
      }
    );
  }

  handlesubmit = event => {
    if (this.validateForm()) {
      if (this.props.values.hiring === ANSWER_IDS.HIRING_OTHER) {
        var hiringother = this.props.values.hiringothers;
      } else {
        var hiringother = STRINGS.NA;
      }
      const obj18 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.props.values.hiring,
        questionId: QUESTION_IDS.MAIN_HIRING_CRITERIA,
        responseInfo: hiringother,
        createDt: this.props.values.date,
      };

      const obj19 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.SPOKEN_TO_OTHER,
        questionId: QUESTION_IDS.WHICH_ADVISORS_CONTACTED,
        responseInfo: this.props.values.selectspokenTo.toString(),
        createDt: this.props.values.date,
      };

      if (this.props.values.assist_with === "") {
        var assist_with = STRINGS.NA;
      } else {
        var assist_with = this.props.values.assist_with;
      }

      const obj20 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.ASSIST_WITH_OTHER,
        questionId: QUESTION_IDS.ASSIST_DECISION_PROCESS,
        responseInfo: assist_with,
        createDt: this.props.values.date,
      };
      // console.log(obj18,obj19,obj20)
      this.props.handleSubmit3(obj18, obj19, obj20);
    }
  };

  validateForm() {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;
    if (this.props.values.hiring === "") {
      formIsValid = false;
      errors["hiringerror"] = "Kindly select an option below to proceed";
    }

    if (
      this.props.values.hiring === ANSWER_IDS.HIRING_OTHER &&
      this.props.values.hiringothers === ""
    ) {
      formIsValid = false;
      errors["hiring_other_error"] = "This is a required field";
    }
    // if(this.props.values.assist_with === ""){
    //   formIsValid = false;
    //   errors["assist_with_error"] = "Kindly select an option below to proceed";
    // }
    if (!this.props.values.selectspokenTo.length) {
      formIsValid = false;
      errors["spokenToerror"] = "Kindly select an option below to proceed";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "Slide2_4",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "slide2_4_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const { handleInput, values, handlecheckbox4 } = this.props;
    const { spokenTo } = this.state;
    const { checkedItems } = this.state;
    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  What do you mainly look for when hiring an advisor?
                  <div id="rsp_email" className="error">
                    {this.state.errors.hiringerror}
                  </div>
                </h2>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    checked={values.hiring === ANSWER_IDS.HIRING_PERSONALITY}
                    value={ANSWER_IDS.HIRING_PERSONALITY}
                    onChange={handleInput(this)}
                  />
                  Personality fit
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    checked={values.hiring === ANSWER_IDS.HIRING_EXPERIENCE}
                    value={ANSWER_IDS.HIRING_EXPERIENCE}
                    onChange={handleInput(this)}
                  />
                  Years of experience
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    checked={values.hiring === ANSWER_IDS.HIRING_TRACK_RECORD}
                    value={ANSWER_IDS.HIRING_TRACK_RECORD}
                    onChange={handleInput(this)}
                  />
                  Successful track record
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    checked={values.hiring === ANSWER_IDS.HIRING_LOCATION}
                    value={ANSWER_IDS.HIRING_LOCATION}
                    onChange={handleInput(this)}
                  />
                  Location
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    value={ANSWER_IDS.HIRING_EXPERTISE}
                    checked={values.hiring === ANSWER_IDS.HIRING_EXPERTISE}
                    onChange={handleInput(this)}
                  />
                  Expertise in specific services
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hiring"
                    value={ANSWER_IDS.HIRING_OTHER}
                    checked={values.hiring === ANSWER_IDS.HIRING_OTHER}
                    onChange={handleInput(this)}
                  />
                  Other
                </label>
                <input
                  type="text"
                  placeholder="IF OTHER PLEASE SPECIFY"
                  className="additional"
                  value={values.hiringothers}
                  name="hiringothers"
                  onChange={handleInput(this)}
                  disabled={
                    values.hiring !== ANSWER_IDS.HIRING_OTHER
                      ? "disabled"
                      : null
                  }
                />
                <div id="rsp_email" className="error">
                  {this.state.errors.hiring_other_error}
                </div>
              </div>

              <div className="col-md-12">
                <h2>
                  Which of the advisor matches have you spoken to?
                  <div id="rsp_email" className="error">
                    {this.state.errors.spokenToerror}
                  </div>
                </h2>
                {spokenTo.map(checkbox => (
                  <label className="radio-inline" key={checkbox.sellerId}>
                    <input
                      type="checkbox"
                      disabled={values.checknon1 === "None of the above"}
                      checked={values.selectspokenTo.includes(
                        checkbox.sellerNm + "(Sid-" + checkbox.sellerId + ")"
                      )}
                      name={checkbox.sellerNm}
                      value={checkbox.sellerId}
                      onChange={handlecheckbox4}
                    />
                    {checkbox.sellerNm}
                  </label>
                ))}

                <label className="radio-inline">
                  <input
                    type="checkbox"
                    name="selectspokenTo"
                    checked={values.selectspokenTo.includes(
                      "None of the above"
                    )}
                    value="None of the above"
                    onChange={handlecheckbox4}
                  />
                  None of the above
                </label>
              </div>

              <div className="col-md-12">
                <h2>
                  Is there anything we can do to assist you with your decision
                  making process?
                </h2>
                <input
                  type="text"
                  className="additional"
                  name="assist_with"
                  value={values.assist_with}
                  onChange={handleInput(this)}
                ></input>
                <div id="rsp_email" className="error">
                  {this.state.errors.assist_with_error}
                </div>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer", marginLeft: UI.MARGIN_LEFT }}
                  value="NEXT"
                  onClick={this.handlesubmit}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Slide2_4;
